import {Injectable} from '@angular/core';
import {HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AppService} from '@shared/services/app.service';
import {CredentialsService} from '@app/auth/credentials.service';

export const NOT_TOAST_ERROR = new HttpContextToken<boolean>(() => false);

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private credentialsService: CredentialsService,
                private appService: AppService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(err => {
                if (err?.status === 401 || !this.credentialsService.isAuthenticated()) {
                    // auto logout if 401 response returned from api
                    this.credentialsService.logout();
                }

                if (!request.context.get(NOT_TOAST_ERROR)) {
                    this.appService.toastError('Api Error', err);
                }

                return throwError(err);
            }));
    }
}
